import React from "react";
import { Header } from "react-native-elements";
import { StyleSheet, Dimensions, View, Text } from "react-native";
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";
import firebase from "firebase";
const { height, width } = Dimensions.get("window");

const CustomHeader = ({
  title,
  leftIcon,
  containerWidth,
  rightIcon,
  containerStyle,
  titleColor,
  centerComponent,
  leftContainerStyle,
}) => {
  return (
    <Header
      containerStyle={containerStyle ? containerStyle : styles.container}
      leftComponent={leftIcon ? leftIcon : null}
      rightComponent={rightIcon ? rightIcon : null}
      leftContainerStyle={leftContainerStyle ? leftContainerStyle : null}
      centerComponent={
        centerComponent
          ? centerComponent
          : {
              text: title,
              style: [
                styles.text,
                {
                  color: titleColor ? titleColor : "#fff",
                  width: containerWidth ? containerWidth : width * 0.5,
                },
              ],
            }
      }
    />
  );
};

export default CustomHeader;

const styles = StyleSheet.create({
  adminView: {
    width: 40,
    height: 40,
    marginRight: 5,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    borderRadius: 20,
  },
  adminText: { fontFamily: "avenir-h", fontSize: RFValue(13) },
  container: {
    backgroundColor: "#181d21",
    flexGrow: 0.05,
    borderBottomColor: "#181d21",
  },
  text: {
    fontSize: RFValue(16),
    fontFamily: "avenir-h",
    textAlign: "center",
  },
});
